import { apiService } from './apiService'

const parseResponse = async (response) => {
  const payload = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(payload.message || `HTTP error! status: ${response.status}`)
    error.status = response.status
    error.details = payload
    throw error
  }
  return payload
}

export const outreachService = {
  async getContacts({ page = 1, limit = 50, search = '' } = {}) {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    })
    if (search.trim()) params.set('search', search.trim())

    const response = await apiService.request(`/api/outreach/contacts?${params}`, { method: 'GET' })
    return parseResponse(response)
  },

  async importContacts(payload) {
    const response = await apiService.request('/api/outreach/contacts/import', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
    return parseResponse(response)
  },

  async prepareContact(contactId) {
    const response = await apiService.request(
      `/api/outreach/contacts/${encodeURIComponent(contactId)}/prepare`,
      { method: 'POST', body: '{}' }
    )
    return parseResponse(response)
  },

  async generateDraft(contactId) {
    const response = await apiService.request(
      `/api/outreach/contacts/${encodeURIComponent(contactId)}/draft`,
      { method: 'POST', body: '{}' }
    )
    return parseResponse(response)
  },

  async saveDraft(contactId, payload) {
    const response = await apiService.request(
      `/api/outreach/contacts/${encodeURIComponent(contactId)}/draft`,
      { method: 'PUT', body: JSON.stringify(payload) }
    )
    return parseResponse(response)
  },

  async approveDraft(contactId, revision) {
    const response = await apiService.request(
      `/api/outreach/contacts/${encodeURIComponent(contactId)}/draft/approve`,
      { method: 'POST', body: JSON.stringify({ revision }) }
    )
    return parseResponse(response)
  },

  async getDeliveryConfig() {
    const response = await apiService.request('/api/outreach/delivery/config', { method: 'GET' })
    return parseResponse(response)
  },

  async getDeliveries(contactId) {
    const response = await apiService.request(
      `/api/outreach/contacts/${encodeURIComponent(contactId)}/deliveries`,
      { method: 'GET' }
    )
    return parseResponse(response)
  },

  async sendApprovedDraft(contactId, revision) {
    const response = await apiService.request(
      `/api/outreach/contacts/${encodeURIComponent(contactId)}/draft/send`,
      { method: 'POST', body: JSON.stringify({ revision, confirmed: true }) }
    )
    return parseResponse(response)
  },
}
